export const GET_ORG_LOADING = "get/org/loading"
export const GET_ORG_ERROR = "get/org/error"
export const GET_ORG_SUCCESS = "get/org/success"

export const PATCH_ORG_LOADING = "patch/org/loading"
export const PATCH_ORG_ERROR = "patch/org/error"
export const PATCH_ORG_SUCCESS = "patch/org/success"

